import {mapGetters} from 'vuex'
export const invoicesMixin = {
    computed: {
        ...mapGetters([
            'getInvoiceTypes',
            'account'
        ]),
    },
    methods: {
        normalizeInvoice: function (invoice) {
            return {
                bookingInvoiceLinkedId: invoice.bookingInvoiceLinkedId,
                id: invoice.id,
                bookingRelationsQuantity: invoice.bookingRelationsQuantity,
                name: invoice.invoiceName? invoice.invoiceName : 'End costumer',
                vatNr: invoice.invoiceTaxpayerNumber? invoice.invoiceTaxpayerNumber : '99999999',
                systemType: invoice.invoiceSystemType,
                targetType: invoice.targetType,
                type: this.invoiceType(invoice.invoiceType),
                date: invoice.date,
                value: invoice.invoicE_TotalDocumento,
                url: invoice.invoicE_Url,
                isActive: invoice.isActive,
                email: invoice.invoiceClientEmail,
                code: invoice.invoicE_NumeroDocumento+ '/' + invoice.invoicE_Serie,
                originalObj: invoice
            }
        },
        invoiceType: function(invoiceTypeId) {
            return this.getInvoiceTypes.filter(storedInvoiceType => {
                return storedInvoiceType.id == invoiceTypeId
            })[0]
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/invoices.js